import { IComponentOptions } from "angular";
import { ChangeJournalItemComponentController } from "./controller";

export const vsComponentName = "changeJournalItemComponent";

export const changeJournalItemComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controller: ChangeJournalItemComponentController,
  bindings: {
    logItem: "<",
  },
};
